




















import ServiceForm from '@/components/service/ServiceForm.vue';
import ServiceUtils, { Service } from '@/utils/ServiceUtils';
import Vue from 'vue';

export default Vue.extend({
  components: { ServiceForm },

  data(): {
    state: {
      valid: boolean;
      submit: boolean;
      errors?: any[];
    };
    item?: Partial<Service>;
  } {
    return {
      state: {
        valid: false,
        submit: false,
        errors: undefined,
      },
      item: undefined,
    };
  },

  async mounted() {
    this.item = ServiceUtils.service.generateDefault();
  },

  methods: {
    async handleSubmit() {
      if (this.item) {
        try {
          this.state.errors = undefined;
          this.state.submit = true;
          (this.$refs.form as any).validate();

          this.item = ServiceUtils.service.generateDefault(
            await ServiceUtils.service.api.create(this.item)
          );

          (this.$refs.form as any).resetValidation();
          this.$toast.push({
            text: this.$t('success.create', [this.$tc('service.label')]),
            type: 'success',
          });
          this.$router.replace({ name: 'service-list' });
        } catch (error) {
          this.$toast.push({
            text: this.$t('error.create', [this.$tc('service.label')]),
            type: 'error',
          });
          this.state.errors = error; // TODO: handle errors
        } finally {
          this.state.submit = false;
        }
      }
    },
  },
});
